<template>
  <div class="crud_module--mass_update_modal">
    <div class="inner-wrap">
      <div v-if="empty_current_config_cp_numbers.length > 0">
        <div class="notice">

            <el-alert
              :title="$t('message.mass_update_warning')"
              type="error"
              :description="$t('field.general.cp_no')+':'"
              show-icon>
            </el-alert>

        </div>
        <div>
          <el-tag
            class="empty-current-config"
            v-for="empty_current_config_cp_number in empty_current_config_cp_numbers"
            :key="empty_current_config_cp_number"
            type="danger"
            size="mini">
            {{empty_current_config_cp_number}}
          </el-tag>
        </div>
      </div>
      <div v-else class="mass-update__container">
        <div class="mass-update__options">
          <div v-for="item in Object.keys(configJson)" :key="item" v-show="typeof selectedConfigJson[item] == 'undefined'">
            <el-button plain :item="item" @click="addSelectedObject(item)" size="mini" class="mass-update__options-btn">{{item}}</el-button>
          </div>
        </div>
        <el-form class="mass-update__selected-options" label-width="120px">

            <div v-for="item in Object.keys(selectedConfigJson)" :key="item">
              <div class="wrap" v-if="selectedConfigJson[item]['Type'] == 'Text'">
                <el-form-item :label="item" class="item">
                  <el-input
                      :id="item"
                      v-model="selectedConfigJson[item]['Value']"
                      size="mini"
                      clearable>
                  </el-input>
                  <div v-if="is_debug" class="debug-value">{{selectedConfigJson[item]['Value']}}</div>
                </el-form-item>
                <el-button class="mass-update__delete-btn" @click="deleteSelectedObject(item)" type="danger" icon="el-icon-delete" circle></el-button>
              </div>

              <div class="wrap" v-if="selectedConfigJson[item]['Type'] == 'Selection'">
                <el-form-item :label="item" class="item">
                  <el-select v-model="selectedConfigJson[item]['Value']" :placeholder="selectedConfigJson[item]['Value']" size="mini">
                      <el-option
                        v-for="option in selectedConfigJson[item]['Option']"
                        :key="option"
                        :label="option"
                        :value="option"
                        size="mini">
                      </el-option>
                  </el-select>
                  <div v-if="is_debug" class="debug-value">{{selectedConfigJson[item]['Value']}}</div>
                </el-form-item>
                <el-button class="mass-update__delete-btn" @click="deleteSelectedObject(item)" type="danger" icon="el-icon-delete" circle></el-button>
              </div>

              <div class="wrap" v-if="selectedConfigJson[item]['Type'] == 'Range'">
                <el-form-item :label="item" class="item">
                  <el-tag class="range-tag" size="mini">
                    Min: {{selectedConfigJson[item]['Option'][0]}}, 
                    Max: {{selectedConfigJson[item]['Option'][1]}}, 
                    Step: {{selectedConfigJson[item]['Option'][2]}}
                  </el-tag>
                  <el-input
                      :id="item"
                      v-model="selectedConfigJson[item]['Value']"
                      size="mini"
                      clearable>
                  </el-input>
                  <div v-if="is_debug" class="debug-value">{{selectedConfigJson[item]['Value']}}</div>
                </el-form-item>
                <el-button class="mass-update__delete-btn" @click="deleteSelectedObject(item)" type="danger" icon="el-icon-delete" circle></el-button>
              </div>

            </div>
        </el-form>
      </div>
      <div class="action-btn">
        <el-button @click="closePopup">{{ $t("button.back") }}</el-button>
        <el-button v-if="empty_current_config_cp_numbers.length == 0" type="primary" @click="massUpdate" :disabled="Object.keys(selectedConfigJson).length == 0">
          {{ $t("button.save") }}
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    selectedConfig: Object,
    currentSetting: Array,
    close: { type: Function },
    selectedCpIdArray: Array,
  },

  async beforeMount() {
    await this.$axios
      .post("/cp_locs/cp_mass_update", {
        cpIds: this.selectedCpIdArray,
      })
      .then((res) => {})
      .catch((err) => {
        this.empty_current_config_cp_numbers = err.response.data;
      });
  },

  methods: {
    closePopup() {
      this.close();
    },
    async massUpdate() {
      await this.$axios
        .post("/cp_locs/cp_mass_update", {
          cpIds: this.selectedCpIdArray,
          commonConfigJson: this.selectedConfigJson,
        })
        .then((res) => {
          if (res.status == 200) {
            this.close();
          }
        })
        .catch((err) => {});
    },
    addSelectedObject(key){
      this.selectedConfigJson[key] = this.configJson[key];
      this.$forceUpdate();
    },
    deleteSelectedObject(key){
      delete this.selectedConfigJson[key];
      this.$forceUpdate();
    }
  },
  data() {
    return {
      is_debug: false,
      empty_current_config_cp_numbers: [],
      configJson: {
        "Time Zone": {
          Type: "Range",
          Authority: "Admin",
          Value: 8,
          Option: [-12, 13, 1],
        },
        "Time Slot Maximum (Min)": {
          Type: "Text",
          Authority: "Admin",
          Value: "525",
        },
        "Server Path": {
          Type: "Text",
          Authority: "Everyone",
          Value: "ws://dev1-ev.cstl.com.hk/evcs/ocpp/",
        },
        "Time Select Stop Button": {
          Type: "Selection",
          Authority: "Admin",
          Value: "Hidden",
          Option: ["Show", "Hidden"],
        },
        Clock: {
          Type: "Selection",
          Authority: "Everyone",
          Value: "Hidden",
          Option: ["Show", "Hidden"],
        },
        "Network Timeout (ms)": {
          Type: "Range",
          Authority: "Everyone",
          Value: 5000,
          Option: [500, 30000, 500],
        },
        "Remote OCPP Server Path": {
          Type: "Text",
          Authority: "Everyone",
          Value: "",
        },
        "Auto Unlock Interval (ms)": {
          Type: "Range",
          Authority: "Everyone",
          Value: 0,
          Option: [0, 10000, 100],
        },
        "LPRS Engine": {
          Type: "Text",
          Authority: "Admin",
          Value: "0.0.0.0",
        },
        "Maximum Capacity (A)": {
          Type: "Range",
          Authority: "Admin",
          Value: 32,
          Option: [0, 32, 1],
        },
        "UART Port": {
          Type: "Selection",
          Authority: "Admin",
          Value: "RS485",
          Option: ["RS232", "RS485"],
        },
        "Time Select Fully Charge": {
          Type: "Selection",
          Authority: "Admin",
          Value: "Hidden",
          Option: ["Show", "Hidden"],
        },
        "Charging detail": {
          Type: "Selection",
          Authority: "Admin",
          Value: "Hidden",
          Option: ["Show", "Hidden"],
        },
        Window: {
          Type: "Selection",
          Authority: "Admin",
          Value: "Full",
          Option: ["Full", "Shrink"],
        },
        LPRS: {
          Type: "Text",
          Authority: "Admin",
          Value: "0.0.0.0",
        },
        Type: {
          Type: "Selection",
          Authority: "Admin",
          Value: "Socket",
          Option: ["Socket", "Cable"],
        },
        "Time Select Interval Min": {
          Type: "Range",
          Authority: "Admin",
          Value: "15",
          Option: [1, 30, 5],
        },
        Authentication: {
          Type: "Selection",
          Authority: "Admin",
          Value: "Subscription",
          Option: [
            "Plug & Charge",
            "Key",
            "SmartPad",
            "TimeSelect",
            "NFC",
            "Subscription",
            "Monthly",
            "Kiosk",
            "Autotoll",
          ],
        },
        "Default Capacity (A)": {
          Type: "Range",
          Authority: "Everyone",
          Value: "32",
          Option: [0, 32, 1],
        },
        "Backdoor Server": {
          Type: "Text",
          Authority: "Admin",
          Value: "",
        },
        "End upon state A": {
          Type: "Selection",
          Authority: "Admin",
          Value: "No",
          Option: ["Yes", "No"],
        },
        "Custom Fields": {
          Type: "Selection",
          Authority: "Admin",
          Value: "Yes",
          Option: ["Yes", "No"],
        },
      },
      selectedConfigJson: {}
    };
  },
};
</script>

<style lang="scss">
.crud_module--mass_update_modal{
  // display: flex;
  
  width: 70vw;
  .inner-wrap {
    // height: 90%;
    // width: 95%;
    // max-width: 800px;
    // max-height: 60%;
    display: flex;
    flex-direction: column;
    padding: 20px;
    background-color: #ffffff;
    .form {
      flex-grow: 1;
      overflow-y: scroll;
      height: 70vh;
      .row {
        display: flex;
        width: 100%;
        max-width: 100%;
        .field {
          flex-grow: 1;
          // width: 100%;
          max-width: 100%;
          :first-child {
            margin-right: 5px;
          }
          &:not(:first-child) {
            margin-left: 5px;
          }
        }
      }
      .checkbox-group {
        display: flex;
        align-items: center;
      }
      .label-group,
      .control-group {
        display: flex;
        flex-direction: column;
        justify-content: center;
        .label {
          width: 100%!important;
          // min-width: 150px;
        }
        input:not([type="checkbox"]) {
          height: 30px;
          // width: 100%;
        }
        textarea {
          width: 100%;
        }
      }
      .el-form-item {
        margin-bottom: 10px;
        .el-select {
          width: 100%;
        }
        select {
          height: 40px;
          line-height: 40px;
          width: 100%;
        }
      }
      .field {
        &:not(:last-child) {
          // margin-bottom: 10px;
        }
      }
    }
    .action-btn {
      display: flex;
      justify-content: space-between;
      margin-top: 20px;
    }
  }
}

.mass-update__container {
  min-height: 71vh;
  max-height: 71vh;
}

.mass-update__options {
  display: inline-block;
  width: 20%;
  overflow: scroll;
  max-height: 71vh;
}

.mass-update__options-btn {
  width:100%;
  margin-bottom: 2px;
}

.mass-update__selected-options {
  display: inline-block;
  width: 80%;
  vertical-align: top;
  overflow-x: hidden;
  max-height: 71vh;
  padding-top: 15px;
}
.mass-update__selected-options .wrap {
  border-bottom: 1px solid #ccc;
  position: relative;
}
.mass-update__selected-options .item {
  display: inline-block;
  position:relative;
  width:90%;
}
.mass-update__delete-btn {
  position: absolute;
  top: 0;
  right: 0;
}
.mass-update__container .debug-value {
  position:absolute; bottom: -20px; width:1200px; font-size:11px
}
.mass-update__container .range-tag {
  position:absolute; top: -15px; font-size:11px
}
.mass-update__container .el-form-item {
  margin-top: 20px;
  margin-bottom: 10px;
  display: flex!important;
  align-items: center;
}
.mass-update__container .el-form-item__label {
  font-size: 12px;
  line-height: 1.1em;
  display: flex;
  align-items: center;
  text-align: left;
  margin-left: 10px;
  position: relative;
}
.mass-update__container .el-form-item__content{
  display: flex;
  align-items: center;
  margin-left: unset!important;;
}
.mass-update__container .el-input,
.mass-update__container .el-select {
  width: 520px;
}
.crud_module--mass_update_modal .empty-current-config {
  margin-right: 5px;
  margin-top: 5px;
  text-align: center;

}
.crud_module--mass_update_modal .empty-current-config:last-of-type {
  margin-right: unset;
}
</style>